// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.v-dialog .pit-card[data-v-16b571b5] {
  background: white !important;
}
.pit-card .test-block[data-v-16b571b5] .v-input {
  padding-top: 0;
  margin-top: 0;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
